import Navbar from "../components/navbar";
import Imagebg from "../components/imagebg";
import Footer from "../components/footer";
const home =()=> {
    console.log('hi');
    return (
        <div>
            <Navbar/>
            <Imagebg/>
            <Footer/>
        </div>
    ); 
}

export default home;
